<!--
 * @author: Reaper
 * @name: 
 * @description: 
 * @Date: 2021-11-17 10:14:42
-->

<template>
  <div id="sportData">
    <!-- <van-button type="primary" @click="JumpToSportRecordDetail">
      跳传运动记录详情
    </van-button> -->
    <!-- <van-empty description="暂无信息" /> -->
    <!-- 无处方 -->
    <NoSportPlan v-if="state == 0" />

    <!-- 休息日 -->

    <Rest v-if="state == 1" />

    <!-- 制定计划 -->
    <!-- <Customize v-if="state == 3" :time="time" /> -->
    <p v-if="state == 3">暂无运动计划</p>

    <!-- 未执行的运动计划 -->
    <template v-if="state == 2">
      <div
        class="sport-prescription-item"
        v-for="(item, index) in sportPlan"
        :key="index"
        :style="{ background: `url(${imgUrl + item.sports[0]['imageUrl']})` }"
        @click="JumpToSportRecordDetail(item)"
      >
        <div class="sportModel-name">
          <h2>{{ item.name }}</h2>
          <p class="sport-name">
            <span v-for="(sport, num) in item.sports" :key="num">{{
              sport.name
            }}</span>
          </p>
          <p style="color: #f5f906">完成（{{ item.endTime }}）</p>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { Toast } from "vant";
import moment from "moment";
import { mapState } from "vuex";
import Customize from "../../views/prescription/PrescriptionDetails/sport/customize";
import Rest from "../../views/prescription/PrescriptionDetails/sport/rest";
import NoSportPlan from "../../views/prescription/PrescriptionDetails/sport/noSportPlan";
// import SportPrescription from "../../views/prescription/PrescriptionDetails/sport/index.vue";
export default {
  components: {
    Customize,
    Rest,
    NoSportPlan,
  },
  computed: { ...mapState("globalConstant", ["imgUrl"]) },
  data() {
    return {
      sportPlan: [],
      state: 0,
      oNotStart: false,

      time: moment(new Date()).format(),
      startTime: new Date("2022-03-07 00:00:00"),
      endTime: new Date("2022-03-07 23:59:59"),
    };
  },
  created() {
    // this.getSportPrescriptionToNotStart();
    this.GetSportPrescriptionDetailsOfTheNextSevenDays();
  },
  methods: {
    /**
     * @author: Reaper
     * @name:getSportPrescriptionToNotStart
     * @description:未开始的处方
     * @Date: 2021-10-20 16:30:26
     */

    getSportPrescriptionToNotStart() {
      this.$apis.Prescription.GetSportPrescriptionToNotStart().then((res) => {
        //判断是否拥有运动处方
        console.log(res.data != null);
        res.data != null ? (this.oNotStart = true) : (this.oNotStart = false);
      });
    },

    /**
     * @author: Reaper
     * @name:GetSportPrescriptionDetailsOfTheNextSevenDays
     * @description:获取进行的运动计划
     * @Date: 2021-08-12 08:45:00
     */

    async GetSportPrescriptionDetailsOfTheNextSevenDays() {
      // await this.getSportPrescriptionToNotStart();
      await this.$apis.Prescription.GetSportPrescriptionDetailsOfTheNextSevenDays().then(
        (res) => {
          console.log(res);
          if (res.data.length <= 0 && this.oNotStart) {
            this.state = 3;
          } else {
            // let timeArr = res.data.map((d) => {
            //   return {
            //     startDate: d.startDate,
            //     endDate: d.endDate,
            //   };
            // });
            // this.showWay(timeArr);
          }
        }
      );
    },

    /**
     * @author: Reaper
     * @name:showWay
     * @description:运动处方显示
     * @Date: 2021-08-12 08:49:43
     */
    showWay(DateList) {
      let getTime = (date) => {
        return new Date(date).getTime();
      };
      let date = getTime(moment(this.time).format("YYYY-MM-DD"));

      //判断当前选择的日期是否大于处方周期最后的结束时间
      let draftFlag =
        date <
        getTime(
          moment(DateList[DateList.length - 1].endDate).format("YYYY-MM-DD")
        );

      //判断当前选择的日期是否存在于运动处方周期中
      let isSportPrescription = DateList.some((t) => {
        let startTime = getTime(moment(t.startDate).format("YYYY-MM-DD"));
        let endTime = getTime(moment(t.endDate).format("YYYY-MM-DD"));
        return date >= startTime && date <= endTime;
      });

      //判断显示状态
      if (isSportPrescription) {
        this.GetPlanPrescriptions();
      }
      if (!isSportPrescription && draftFlag) {
        this.state = 0;
      }
      if (!draftFlag && this.oNotStart) {
        this.state = 3;
      } else {
        this.state = 0;
      }
    },

    /**
     * @author: Reaper
     * @name: GetPlanPrescriptions
     * @description: 根据时间获取计划
     * @Date: 2021-08-11 15:09:56
     */

    GetPlanPrescriptions() {
      this.$apis.Prescription.GetPlanPrescriptions({
        Time: this.time,
      }).then((res) => {
        console.log(res.data);
        if (res.data == null) {
          this.state = 1;
          return;
        }

        res.data.map((item, i) => {
          item.sportPlans.map((chil, k) => {
            chil.details.map((sun, k) => {
              if (sun.isFinish) {
                this.sportPlan.push(sun);
              }
            });
          });
        });

        this.sportPlan.sort((a, b) => {
          return b.id - a.id;
        });
        // this.sportPlan = res.data.details;
        // this.$store.state.globalConstant.PlanId = res.data.id;
        this.state = 2;
      });
    },
    /*
     *@author: luoluodafang
     *@name:携带运动开始时间，结束时间跳转详情页面
     *@date: 2022-06-07 11:30:27
     *@description:
     */
    JumpToSportRecordDetail(item) {
      console.log(item);
      if (item.isFinish == false) {
        Toast("请先完成运动打卡！");
        return;
      }
      console.log(item.startTime);
      console.log(item.endTimeTime);

      this.$router.push({
        path: "/sportRecordDetails",
        query: {
          startTime: moment(item.startTime).valueOf(),
          endTime: moment(item.endTime).valueOf(),
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
#sportData {
  background: #fff;
  min-height: 100vh;
  // width: 100%;
  // height: 100%;
  .rest {
    span {
      font-size: 0.3rem;
    }
  }
  .sport-prescription-item {
    position: relative;
    display: flex;
    width: 95%;
    height: 2rem;
    margin: 0.3rem auto;
    // box-shadow: 1px 5px 10px #f2f2f2;
    background-size: cover !important;
    border-radius: 0.1rem;

    .sportModel-name {
      position: absolute;
      z-index: 1002;
      font-size: 0.35rem;
      color: #f2f2f2;
      padding: 0.25rem;
      .sport-name {
        font-size: 0.25rem;
        line-height: 0.4rem;
        padding: 0.1rem 0;
        span {
          margin-right: 0.2rem;
        }
      }
    }
    &::before {
      position: absolute;
      width: 100%;
      height: 100%;
      content: "";
      background: rgba(0, 0, 0, 0.3);
      // filter: blur(10px);
    }
  }
  p {
    font-size: 0.4rem;
  }
}
</style>
